/**
 * Renders placeholder rentals instead of calling the catalog.
 *
 * Off: the widget queries the real catalog. The fixtures are kept for
 * developing without a site, for Storybook and for tests — flip to `true` to
 * use them.
 */
export const USE_MOCK_DATA = false;

/** Rentals app definition id — services are scoped to this app in the catalog. */
export const RENTALS_APP_ID = 'ff5d6eb1-65e4-4f9a-8b14-64d34c12cc2e';

/** Section id of the rental page as registered in Dev Center (`appPage.id`). */
export const RENTAL_PAGE_SECTION_ID = 'Rental Page';

/**
 * `Wix.Settings.openDashboard`'s `state` for the rentals list BO page —
 * matches its `route` in `packages/rentals-list/src/pages/index.json`.
 */
export const RENTALS_BO_RENTALS_LIST_STATE = 'rental-list';

/**
 * Rentals per page. `queryServices` returns up to 100; 8 matches the builder
 * component's grid so both surfaces page identically.
 */
export const SERVICES_PAGE_SIZE = 8;

/** Descriptions longer than this are clamped with a More info link, as the builder does. */
export const DESCRIPTION_CHAR_LIMIT = 150;

/** Card image dimensions requested from the media CDN (before CSS scaling). */
export const CARD_IMAGE = {
  width: 480,
  height: 320,
} as const;

/** Target card width the responsive grid lays out against. */
export const CARD_TARGET_WIDTH_PX = 300;

/**
 * `pageName` for generic BI events (src:198) — single-surface app, one constant
 * per `bi-events_generic-events-setup`'s react-web guidance.
 */
export const BI_PAGE_NAME = 'rental_listings_widget';

/**
 * Normalized entity type for generic BI events' `entities` map — derived from
 * `@wix/ambassador-bookings-services-v2-service`'s `wix.ambassador.fqdn`
 * (`wix.bookings.services.v2.service`) per the entities-field normalization rule.
 */
export const BOOKINGS_SERVICE_ENTITY_TYPE = 'bookings_services_service';
